import { render, staticRenderFns } from "./IndirectPositions.vue?vue&type=template&id=36505d21"
import script from "./IndirectPositions.vue?vue&type=script&lang=js"
export * from "./IndirectPositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports